
import { toast } from "@/hooks/use-toast";

export const sendEstimateEmail = async (): Promise<void> => {
  try {
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    toast({
      title: "Email Sent",
      description: "Presales estimate report has been emailed successfully",
    });
  } catch (error) {
    toast({
      title: "Error",
      description: "Failed to send email. Please try again.",
      variant: "destructive",
    });
  }
};
